import { newsLetterRequest } from './newsletter';

const serverBaseDomain = "https://cserver.zirveextrusion.net";
// const serverBaseDomain = "http://127.0.0.1:3000/";
let socket;

const newsletterDBtn = document.getElementById('sies_submit_D');
const newsletterMBtn = document.getElementById('sies_submit_M');


if (newsletterDBtn) {
    newsletterDBtn.addEventListener('click', () => {
        const email = document.getElementById('email_d').value;
        // const token = form.querySelector('[name="cf-turnstile-response"]')?.value;
        const token = document.querySelector('#emailForm_D [name="cf-turnstile-response"]')?.value;
        newsLetterRequest(email, token);
    });
}

if (newsletterMBtn) {
    newsletterMBtn.addEventListener('click', () => {
        // const token = form.querySelector('[name="cf-turnstile-response"]')?.value;
        const token = document.querySelector('#emailForm_M [name="cf-turnstile-response"]')?.value;
        const email = document.getElementById('email_m').value;
        newsLetterRequest(email, token);
    });
}

const initSocket = async () => {

    const isBot = /Lighthouse|Googlebot|PageSpeed|HeadlessChrome|GTmetrix|Pingdom/i.test(navigator.userAgent);
    const isLighthouse = !!window.__Lighthouse__ || !!window.__lighthouse__;

    if (isBot || isLighthouse) {
        console.log("Optimization: Socket connection skipped for automated tool.");
        return;
    }

    import("socket.io-client").then(({ io }) => {
        const storedSocketId = localStorage.getItem('zirve-international-socketId');

        socket = io(serverBaseDomain, {
            transports: ['websocket'],
            reconnection: false,
            reconnectionAttempts: 2,
            timeout: 10000,
            query: {
                storedSocketId: storedSocketId,
                pathname: window.location.pathname
            }
        });

        socket.on('connect_error', (err) => {
            console.warn("Socket unreachable. Standing by...");
            socket.disconnect();
        });

        socket.on('connect', () => {
            console.log('Socket connected successfully');
        });

        socket.on('my-old-messages', (data) => {
            const paging = data.paging;
            const messages = data.messages;
            const chatDisplay = document.getElementById('messages');
            
            if (paging.currentPage === 1 && chatDisplay) {
                messages.forEach((m) => {
                    const div = document.createElement('div');
                    div.className = 'zmP1y chat-list-item';
                    div.innerHTML = getInnerMessage(m);
                    chatDisplay.appendChild(div);
                });
                chatDisplay.scrollTop = chatDisplay.scrollHeight;
            }
        });

        socket.on('new-user-added', (data) => {
            localStorage.setItem('zirve-international-socketId', data.userStoredId);
        });

        socket.on('res-ma-12', data => {
            localStorage.setItem(data.name, data.value);
        });

        socket.on("new-message-created", (data) => {
            const messenger = document.getElementById('messenger');
            const chatDisplay = document.getElementById('messages');

            if (messenger && !messenger.classList.contains('show-m')) {
                messenger.classList.remove('hide-m');
                messenger.classList.add('show-m');
            }
            
            const div = document.createElement('span');
            div.className = 'zmP1y chat-list-item';
            div.innerHTML = getInnerMessage(data);
            
            if (chatDisplay) {
                chatDisplay.appendChild(div);
                chatDisplay.scrollTop = chatDisplay.scrollHeight;
            }
        });

    });

};

window.addEventListener('load', () => {
    setTimeout(initSocket, 4000); 
});


const messengerButton = document.getElementById('messenger-button');
const messenger = document.getElementById('messenger');
const closeMessenger = document.getElementById('close-messenger');
const msgInput = document.getElementById('message-input');
const chatDisplay = document.getElementById('messages');

if (messengerButton) {
    messengerButton.addEventListener('click', () => {
        messenger.classList.add('show-m');
        messenger.classList.remove('hide-m');
    });
}

if (closeMessenger) {
    closeMessenger.addEventListener('click', () => {
        messenger.classList.add('hide-m');
        messenger.classList.remove('show-m');
    });
}

function sendMessage(value) {
    if (value && socket && socket.connected) {
        const storedId = localStorage.getItem('zirve-international-socketId');
        socket.emit('new-message-from-client', { text: value, from: storedId });

        const div = document.createElement('div');
        div.className = 'zmP1y chat-list-item';
        div.innerHTML = getInnerMessage({ type: 'out', text: value });
        
        if (chatDisplay) {
            chatDisplay.appendChild(div);
            chatDisplay.scrollTop = chatDisplay.scrollHeight;
        }

        msgInput.value = "";
        msgInput.style.height = '24px';
    } else {
        console.error("Socket not connected. Cannot send message.");
    }
    msgInput.focus();
}

if (msgInput) {
    msgInput.addEventListener('keydown', (e) => {
        // Adjust height based on content
        if (msgInput.value.length < 60) msgInput.style.height = '24px';
        else if (msgInput.value.length < 120) msgInput.style.height = '46px';
        else msgInput.style.height = '67px';

        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent newline in input
            sendMessage(msgInput.value);
        }
    });
}

function getInnerMessage(m) {
    if (m.type === 'in') return `<div><div class="BSRfD Z34QH swol0"><div class="WdbOB"><div class="rPIaQ"><div class="_8Wp2u" style="border-radius: 4px 8px 8px; min-width: 50px; max-width: 340px;">
    <div style="background: rgb(255, 255, 255); color: rgb(0, 0, 0); min-width: 50px; max-width: 340px;" class="Hx0W2 ugYTB">
    <div class="s1KPJZk scDllX8 o2WpKQ2---size-6-medium"><div class="s3NWhVZ"><div>
    <div class="ZCbUH zSgqw inline-message-style">${m.text}</div></div></div></div></div></div></div></div></div></div>`;
    
    if (m.type === 'out') return `<div><div class="BSRfD lxChu swol0"><div class="WdbOB _8WIJ9"><div class="rPIaQ"><div class="_8Wp2u" style="border-radius: 8px; min-width: 50px; max-width: 340px;">
    <div style="background: rgb(0, 75, 128); color: rgb(255, 255, 255); min-width: 50px; max-width: 340px;" class="Hx0W2 ugYTB">
    <div class="s1KPJZk scDllX8 o2WpKQ2---size-6-medium"><div class="s3NWhVZ"><div>
    <div class="ZCbUH zSgqw outline-message-style">${m.text}</div></div></div></div></div></div></div></div></div></div>`;
    
    return '';
}



